import * as THREE from "three";


const steelMaterial = (colorObject) => {
    
    const defaultValues = {
        transparent: true,
        alphaTest: 0.3,
        polygonOffset: true,
        polygonOffsetFactor: -2,
        
        side: THREE.FrontSide,
        alphaToCoverage: true,
        
        color: parseInt(colorObject?.materialValues?.color || 0x777777, 16)
        
        
        //emissive: parseInt(colorObject.materialValues.color,16),
        //emissive: 0x000000,
        
        //depthWrite: true,
        //depthTest: false,
        
        
        //color: isLight ? 0xff0000 : 0x00ff00
        
        //bumpMap: texture,//new THREE.TextureLoader().load("assets/img/textures/bump.jpg"),
        //bumpScale: -1, // Adjust the bump scale as needed
        
        
        //polygonOffsetUnits:-10,
        
    }
    const SteelValues = {
        roughness: 0.6,//colorObject?.materialValues?.roughness || 3,
        metalness: 1,
        //roughnessMap: new THREE.TextureLoader().load("assets/img/textures/metal&roughness.jpg"),
        //metalnessMap: new THREE.TextureLoader().load("assets/img/textures/metal&roughness.jpg"),
        roughnessMap: new THREE.TextureLoader().load("/textures/test.jpg"),
        metalnessMap: new THREE.TextureLoader().load("/textures/test.jpg"),
        normalMap: new THREE.TextureLoader().load("/textures/test.jpg"),
        
    }
    SteelValues.metalnessMap.repeat.set(1, 50);
    SteelValues.roughnessMap.repeat.set(1, 50);
    SteelValues.normalMap.repeat.set(1, 5);

    const materialList = {
        normal: new THREE.MeshStandardMaterial({
            ...defaultValues,
            ...SteelValues,
        }),
        selected: new THREE.MeshStandardMaterial({
            ...defaultValues,
        })
    }
    materialList.normal.normalScale = new THREE.Vector2(0.025, 0.025)
 
    materialList.normal.roughnessMap.wrapS = THREE.RepeatWrapping;
    materialList.normal.roughnessMap.wrapT = THREE.RepeatWrapping;

    materialList.normal.metalnessMap.wrapS = THREE.RepeatWrapping;
    materialList.normal.metalnessMap.wrapT = THREE.RepeatWrapping;
    window.productColorObject = {
        ...colorObject,
        materialList: materialList,
    };
    
    return materialList;
    
    
}
export default steelMaterial;